// backinstock.js (Product detail page ONLY)
// Sticky "Notify me when available" link that survives Horizon DOM re-renders
// Supports BOTH: multi-variant (radio buttons) AND single-variant (no picker)
// Posts subscription to babycentral.co OpenCart endpoint

(function () {
  'use strict';

  var BIS_API_BASE = 'https://babycentral.co';
  var BIS_POST_URL = BIS_API_BASE + '/index.php?route=api/backinstock/postSubscription';

  var BIS_NOTIFY_ICON =
    'https://cdn.shopify.com/s/files/1/0526/8389/9074/files/notify_email_icon_353da3fb-6c07-406f-907c-1e572c90ebb6.png';

  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.indexOf('/products/') !== 0) return;

    var CUSTOMER_EMAIL = (window.BIS_CUSTOMER_EMAIL || '').toString().trim();

    function bisLog() {
      try {
        console.log.apply(console, ['[BackInStock]'].concat([].slice.call(arguments)));
      } catch (e) {}
    }

    function getStoreIdFromBody() {
      var body = document.body;
      if (!body) return null;

      var candidates = [
        body.getAttribute('store_id'),
        body.getAttribute('data-store-id'),
        body.getAttribute('data-store_id'),
        body.dataset ? body.dataset.storeId : null,
        body.dataset ? body.dataset.store_id : null
      ];

      for (var i = 0; i < candidates.length; i++) {
        var val = candidates[i];
        if (val != null && String(val).trim() !== '') {
          return String(val).trim();
        }
      }

      var meta =
        document.querySelector('meta[name="store_id"]') ||
        document.querySelector('meta[name="data-store-id"]');
      if (meta) {
        var metaVal = meta.getAttribute('content');
        if (metaVal && String(metaVal).trim()) return String(metaVal).trim();
      }

      var hidden =
        document.querySelector('input[name="store_id"]') ||
        document.querySelector('#store_id') ||
        document.querySelector('[data-store-id-value]');
      if (hidden) {
        var hiddenVal =
          hidden.value ||
          hidden.getAttribute('value') ||
          hidden.getAttribute('data-store-id-value');
        if (hiddenVal && String(hiddenVal).trim()) return String(hiddenVal).trim();
      }

      if (window.BIS_STORE_ID != null && String(window.BIS_STORE_ID).trim() !== '') {
        return String(window.BIS_STORE_ID).trim();
      }

      return null;
    }

    function getStoreId() {
      var storeId = getStoreIdFromBody();
      bisLog('store_id resolved:', storeId);
      return storeId;
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(String(email || '').trim());
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function cleanTitle(str) {
      return String(str || '')
        .replace(/\s+/g, ' ')
        .replace(/\s*[|–—-]\s*Baby Central.*$/i, '')
        .replace(/\s*[|–—-]\s*.*$/i, function (m) {
          return /baby central/i.test(m) ? '' : m;
        })
        .trim();
    }

   function getProductTitle() {
  function normalizeTitle(str) {
    return String(str || '')
      .replace(/\s+/g, ' ')
      .replace(/\s*[|–—-]\s*Baby Central.*$/i, '')
      .trim();
  }

  function looksLikeBadTitle(str) {
    var s = normalizeTitle(str).toLowerCase();
    if (!s) return true;

    return (
      s === 'sold out' ||
      s === 'added' ||
      s === 'details' ||
      s === 'related products' ||
      s === 'information' ||
      s === 'customer service' ||
      s === 'view all' ||
      s.indexOf('fast singapore delivery') === 0
    );
  }

  function removeSelectedVariantSuffix(title) {
    var cleaned = normalizeTitle(title);
    var selectedLabel = '';

    var checkedRadio =
      document.querySelector('variant-picker input[type="radio"]:checked') ||
      document.querySelector('input[type="radio"][data-variant-id]:checked');

    if (checkedRadio) {
      selectedLabel =
        checkedRadio.getAttribute('value') ||
        checkedRadio.getAttribute('data-option-value') ||
        checkedRadio.getAttribute('aria-label') ||
        checkedRadio.labels && checkedRadio.labels[0]
          ? checkedRadio.labels[0].textContent
          : '';
    }

    selectedLabel = normalizeTitle(selectedLabel);

    if (selectedLabel) {
      var escaped = selectedLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      cleaned = cleaned.replace(new RegExp('\\s[-–—]\\s' + escaped + '$', 'i'), '').trim();
    }

    return cleaned;
  }

  // 1) Most stable: Open Graph title from <head>
  var og =
    document.querySelector('meta[property="og:title"]') ||
    document.querySelector('meta[name="og:title"]');

  if (og) {
    var ogTitle = removeSelectedVariantSuffix(og.getAttribute('content') || '');
    if (!looksLikeBadTitle(ogTitle)) return ogTitle;
  }

  // 2) Product title inside the product information area only
  var productRoot =
    document.querySelector('product-info') ||
    document.querySelector('[id^="ProductInfo-"]') ||
    document.querySelector('[data-product-information]') ||
    document.querySelector('[data-product-info]') ||
    document.querySelector('main');

  if (productRoot) {
    var scopedSelectors = [
      '[data-product-title]',
      'h1.product-title',
      '.product-title',
      '.product__title h1',
      '.product__title',
      'h1'
    ];

    for (var i = 0; i < scopedSelectors.length; i++) {
      var el = productRoot.querySelector(scopedSelectors[i]);
      if (!el) continue;

      var value =
        scopedSelectors[i] === '[data-product-title]'
          ? (el.getAttribute('data-product-title') || el.textContent || '')
          : (el.textContent || '');

      var scopedTitle = removeSelectedVariantSuffix(value);
      if (!looksLikeBadTitle(scopedTitle)) return scopedTitle;
    }
  }

  // 3) JSON-LD Product schema
  var scripts = document.querySelectorAll('script[type="application/ld+json"]');
  for (var j = 0; j < scripts.length; j++) {
    try {
      var raw = scripts[j].textContent || '';
      if (!raw) continue;

      var json = JSON.parse(raw);

      if (Array.isArray(json)) {
        for (var a = 0; a < json.length; a++) {
          if (json[a] && json[a]['@type'] === 'Product' && json[a].name) {
            var arrTitle = removeSelectedVariantSuffix(json[a].name);
            if (!looksLikeBadTitle(arrTitle)) return arrTitle;
          }
        }
      } else if (json && json['@type'] === 'Product' && json.name) {
        var jsonTitle = removeSelectedVariantSuffix(json.name);
        if (!looksLikeBadTitle(jsonTitle)) return jsonTitle;
      } else if (json && json['@graph'] && Array.isArray(json['@graph'])) {
        for (var g = 0; g < json['@graph'].length; g++) {
          var item = json['@graph'][g];
          if (item && item['@type'] === 'Product' && item.name) {
            var graphTitle = removeSelectedVariantSuffix(item.name);
            if (!looksLikeBadTitle(graphTitle)) return graphTitle;
          }
        }
      }
    } catch (e) {}
  }

  // 4) Final fallback: document.title
  var docTitle = normalizeTitle(document.title || '')
    .replace(/\s*[|–—-]\s*Baby Central.*$/i, '')
    .trim();

  if (!looksLikeBadTitle(docTitle)) return docTitle;

  return 'this product';
}

    function getProductForm() {
      return (
        document.querySelector('product-form-component form[action^="/cart/add"]') ||
        document.querySelector('form[action^="/cart/add"]')
      );
    }

    function getAddToCartButton() {
      return (
        document.querySelector('.buy-buttons-block button.add-to-cart-button') ||
        document.querySelector('button.add-to-cart-button') ||
        (getProductForm() ? getProductForm().querySelector('button[type="submit"]') : null)
      );
    }

    function getSelectedVariantRadio() {
      return (
        document.querySelector('variant-picker input[type="radio"][data-variant-id]:checked') ||
        document.querySelector('input[type="radio"][data-variant-id]:checked')
      );
    }

    function getVariantIdFromFormHiddenInput() {
      var form = getProductForm();
      if (!form) return '';

      var input = form.querySelector('input[name="id"]');
      var v = input ? String(input.value || '').trim() : '';
      return v;
    }

    function getSelectedVariantId() {
      var r = getSelectedVariantRadio();
      if (r) {
        var rid = String(r.getAttribute('data-variant-id') || '').trim();
        if (rid) return rid;
      }
      return getVariantIdFromFormHiddenInput();
    }

    function isSelectedVariantAvailable() {
      var r = getSelectedVariantRadio();
      if (r) {
        var av = r.getAttribute('data-option-available');
        if (av === 'true') return true;
        if (av === 'false') return false;

        if (r.getAttribute('aria-disabled') === 'true') return false;
        return null;
      }

      var btn = getAddToCartButton();
      if (!btn) return null;

      if (btn.disabled === true || btn.hasAttribute('disabled')) return false;
      return true;
    }

    function getBuyButtonsContainer() {
      return (
        document.querySelector('.buy-buttons-block') ||
        document.querySelector('product-form-component') ||
        getProductForm()
      );
    }

    var overlay = document.getElementById('backinstock-modal-overlay');
    var modal = document.getElementById('backinstock-modal');

    function ensureModalExists() {
      if (overlay && modal) return;

      overlay = document.createElement('div');
      overlay.id = 'backinstock-modal-overlay';
      overlay.style.display = 'none';

      modal = document.createElement('div');
      modal.id = 'backinstock-modal';

      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) closeModal();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay && overlay.style.display === 'flex') {
          closeModal();
        }
      });
    }

    var prevBodyOverflow = '';
    var prevHtmlOverflow = '';
    var activeVariantId = null;

    function openModal() {
      ensureModalExists();
      prevBodyOverflow = document.body.style.overflow;
      prevHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      overlay.style.display = 'flex';
    }

    function closeModal() {
      if (!overlay) return;
      overlay.style.display = 'none';
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
      activeVariantId = null;
    }

    function showSubscribedScreen() {
      modal.innerHTML = '\
        <h2 id="modal-close-h2">Subscribed!</h2>\
        <p id="modal-close-p">You will be notified once this product is back in stock.</p>\
        <button type="button" id="backinstock-modal-close-ok">Okay</button>\
      ';

      var closeOkBtn = document.getElementById('backinstock-modal-close-ok');
      if (closeOkBtn) closeOkBtn.addEventListener('click', closeModal);
    }

    function showError(msg) {
      alert(msg || 'Failed to subscribe, please try again later.');
    }

    function postSubscription(email, variantId, storeId) {
      var formData = new FormData();
      formData.append('email', email);
      formData.append('variant_id', String(variantId || '').trim());
      formData.append('store_id', String(storeId || '').trim());
      formData.append('product_title', getProductTitle());

      return fetch(BIS_POST_URL, {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'omit'
      }).then(function (res) {
        return res.text().then(function (txt) {
          var json = null;

          bisLog('raw API response status:', res.status);
          bisLog('raw API response body:', txt);

          try {
            json = JSON.parse(txt);
          } catch (e) {}

          if (!res.ok) {
            throw new Error('HTTP ' + res.status + ': ' + txt);
          }

          if (!json) {
            throw new Error('Non-JSON response: ' + txt);
          }

          return json;
        });
      });
    }

    function renderSubscribeModal() {
      ensureModalExists();

      var productTitle = getProductTitle();
      var emailKnown = !!CUSTOMER_EMAIL;

      bisLog('resolved product title:', productTitle);

      if (emailKnown) {
        modal.innerHTML = '\
          <h2 id="backinstock-modal-title">Notify me when available</h2>\
          <p id="backinstock-modal-desc">We&#8217;ll email you when <strong>' + escapeHtml(productTitle) + '</strong> is back in stock.</p>\
          <div id="backinstock-modal-buttons">\
            <button type="button" id="backinstock-modal-cancel">Cancel</button>\
            <button type="button" id="backinstock-modal-ok">Subscribe</button>\
          </div>\
        ';
      } else {
        modal.innerHTML = '\
          <h2 id="backinstock-modal-title">Notify me when available</h2>\
          <p id="backinstock-modal-desc">Enter your email and we&#8217;ll notify you when <strong>' + escapeHtml(productTitle) + '</strong> is back in stock.</p>\
          <div class="backinstock-input-wrap">\
            <input id="backinstock-email-input" type="email" placeholder="" autocomplete="email" />\
            <div id="backinstock-email-error" class="backinstock-error" style="display:none;">Please enter a valid email.</div>\
          </div>\
          <div id="backinstock-modal-buttons">\
            <button type="button" id="backinstock-modal-cancel">Cancel</button>\
            <button type="button" id="backinstock-modal-ok">Subscribe</button>\
          </div>\
        ';
      }

      var btnCancel = document.getElementById('backinstock-modal-cancel');
      var btnOK = document.getElementById('backinstock-modal-ok');

      if (btnCancel) btnCancel.addEventListener('click', closeModal);

      if (btnOK) {
        btnOK.addEventListener('click', function () {
          var emailToUse = CUSTOMER_EMAIL;

          if (!emailKnown) {
            var input = document.getElementById('backinstock-email-input');
            var err = document.getElementById('backinstock-email-error');
            emailToUse = input ? input.value.trim() : '';

            if (!isValidEmail(emailToUse)) {
              if (err) err.style.display = 'block';
              if (input) input.focus();
              return;
            }
            if (err) err.style.display = 'none';
          }

          var storeId = getStoreId();

          if (storeId === null || storeId === undefined || storeId === '') {
            showError('Missing store_id. Please contact support.');
            return;
          }

          if (!activeVariantId) {
            showError('Missing variant_id. Please try again.');
            return;
          }

          bisLog('Subscribe payload:', {
            email: emailToUse,
            variant_id: activeVariantId,
            store_id: storeId,
            product_title: getProductTitle()
          });

          btnOK.disabled = true;

          postSubscription(emailToUse, activeVariantId, storeId)
            .then(function (data) {
              bisLog('API response JSON:', data);

              if (data && data.success) {
                showSubscribedScreen();
              } else {
                btnOK.disabled = false;
                showError((data && data.message) || 'Failed to subscribe.');
              }
            })
            .catch(function (err) {
              console.error('[BackInStock] postSubscription failed:', err);
              btnOK.disabled = false;
              showError(err && err.message ? err.message : 'Failed to subscribe, please try again later.');
            });
        });
      }

      openModal();
    }

    var WRAP_ID = 'bis-notify-link-wrap';

    function ensureLinkExists() {
      var container = getBuyButtonsContainer() || getProductForm();
      if (!container) return null;

      var wrap = container.querySelector('#' + WRAP_ID);
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.id = WRAP_ID;
        wrap.className = 'bis-notify-link-wrap';

        var link = document.createElement('a');
        link.href = '#';
        link.className = 'bis-notify-link';

        var icon = document.createElement('img');
        icon.src = BIS_NOTIFY_ICON;
        icon.alt = '';
        icon.className = 'bis-notify-icon';
        icon.loading = 'lazy';
        icon.decoding = 'async';
        icon.referrerPolicy = 'no-referrer';

        var text = document.createElement('span');
        text.className = 'bis-notify-text';
        text.textContent = 'Notify me when available';

        link.appendChild(icon);
        link.appendChild(text);

        link.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var available = isSelectedVariantAvailable();
          if (available !== false) return;

          var vid = getSelectedVariantId();
          if (!vid) {
            console.error('[BackInStock] Cannot determine selected variant id.');
            return;
          }

          activeVariantId = vid;
          bisLog('active variant id:', activeVariantId);
          renderSubscribeModal();
        });

        wrap.appendChild(link);
        container.appendChild(wrap);
      }

      return wrap;
    }

    function refreshLinkVisibility() {
      var wrap = ensureLinkExists();
      if (!wrap) return;

      var available = isSelectedVariantAvailable();
      wrap.style.display = available === false ? 'block' : 'none';
    }

    refreshLinkVisibility();

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[type="radio"][data-variant-id]')) {
        setTimeout(refreshLinkVisibility, 0);
        setTimeout(refreshLinkVisibility, 80);
        setTimeout(refreshLinkVisibility, 200);
      }
    });

    var container = getBuyButtonsContainer() || document.body;
    var mo = new MutationObserver(function () {
      refreshLinkVisibility();
    });
    if (container) mo.observe(container, { childList: true, subtree: true, attributes: true });

    var vp = document.querySelector('variant-picker') || document.querySelector('[data-block-id*="variant_picker"]');
    if (vp) {
      var mo2 = new MutationObserver(function () {
        refreshLinkVisibility();
      });
      mo2.observe(vp, { childList: true, subtree: true, attributes: true });
    }

    var atc = getAddToCartButton();
    if (atc) {
      var mo3 = new MutationObserver(function () {
        refreshLinkVisibility();
      });
      mo3.observe(atc, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
  });
})();